// tslint:disable:max-line-length

import classnames from "classnames";
import React from "react";
import { Link } from "react-router";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { LocalStorageHelper } from "@travellocal/utils/localStorageHelper";

import "./cookieBar.scss";

export const CookieBar = () => {
  const [isVisible, setVisible] = React.useState(null);

  // visible if cookies have not been accepted
  React.useEffect(() => {
    setVisible(LocalStorageHelper.getItem("accepted-cookies") !== "true");
  }, []);

  const hideCookieBar = React.useCallback(() => {
    LocalStorageHelper.setItem("accepted-cookies", "true");
    setVisible(false);
  }, []);

  return (
    <div className={classnames("cookie-bar", { "is-hidden": !isVisible })}>
      <p>
        We use cookies to provide you with a better service. See our <Link to={WebRoutes.privacy()}>Privacy Policy</Link> for more details, or continue browsing if you're happy with this. You can change the cookie settings in your browser at any time. <a onClick={hideCookieBar}>Ok, hide this message</a>
      </p>
    </div>
  );
}
